import { HelpCircle } from "lucide-react";
import LegalShell from "../components/LegalShell";
import { FAQ_CATEGORIES } from "../data/faq";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  return (
    <LegalShell title="FAQ — Pertanyaan Umum" icon={HelpCircle} active="faq">
      <p className="text-su-muted font-medium mb-6" data-testid="faq-page">
        Jawaban atas pertanyaan yang paling sering ditanyakan seputar SkorUp.io. Tidak menemukan jawabanmu? Hubungi kami lewat menu Lapor/Saran.
      </p>

      <div className="space-y-6">
        {FAQ_CATEGORIES.map((cat) => (
          <div key={cat.title}>
            <h2 className="font-heading font-black text-lg mb-2 text-su-primary">{cat.title}</h2>
            <div className="card-chunky px-4">
              <Accordion type="single" collapsible>
                {cat.items.map(([q, a], i) => (
                  <AccordionItem key={q} value={`${cat.title}-${i}`} data-testid={`faq-item-${cat.title.replace(/\s+/g, "-").toLowerCase()}-${i}`}>
                    <AccordionTrigger className="text-left font-heading font-bold text-sm hover:no-underline">{q}</AccordionTrigger>
                    <AccordionContent className="text-sm text-su-muted leading-relaxed">{a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        ))}
      </div>
    </LegalShell>
  );
}
